import React from 'react';
import NextLink from 'next/link';

interface LinkProps {
  href: string;
  className?: string;
  children: React.ReactNode;
  target?: '_blank' | '_self' | '_parent' | '_top';
  rel?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const Link: React.FC<LinkProps> = ({ 
  href, 
  className = '', 
  children, 
  target,
  rel,
  onClick 
}) => {
  // Handle external links
  const isExternal = href?.startsWith('http') || href?.startsWith('//');

  if (isExternal) {
    return (
      <a
        href={href}
        className={className}
        target={target || '_blank'}
        rel={rel || 'noopener noreferrer'}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  // Use Next.js Link for internal navigation
  return (
    <NextLink 
      href={href}
      className={className}
      target={target}
      rel={rel}
      onClick={onClick}
    >
      {children}
    </NextLink>
  );
};

export default Link;